import React from "react";
import { formatKey } from "../../_helper";
import IdentificationImage from "./IdentificationImage";

const AccountDetailsProfile = ({
  title,
  data,
  columns = 2,
  img,
  className = "tw-container tw-mx-auto tw-p-5 tw-bg-white tw-rounded-[10px] tw-shadow-md tw-relative",
  identificationPicFront,
  identificationPicBack,
}) => {
  const gridColumnsClass =
    columns === 1
      ? "tw-grid-cols-1"
      : columns === 2
      ? "lg:tw-grid-cols-2"
      : columns === 3
      ? "lg:tw-grid-cols-3"
      : `lg:tw-grid-cols-${columns}`;

  return (
    <section className={className}>
      {img !== undefined && (
        <div className="tw-absolute tw-size-20 tw-top-4 tw-rounded-full tw-right-10 tw-bg-white tw-shadow-lg tw-border-2 tw-p-2 tw-border-primary/5">
          <img
            src={img || "/imgs/partner.png"}
            alt="Profile"
            className="tw-size-full tw-rounded-full tw-object-cover"
          />
        </div>
      )}
      <h3 className="tw-text-xl tw-font-semibold tw-text-red-600 tw-mb-4 tw-border-b tw-pb-2">
        {title}
      </h3>
      <div
        className={`tw-grid ${gridColumnsClass}  tw-grid-cols-1  tw-gap-2 tw-text-gray-700`}
      >
        {Object.entries(data).map(([key, value]) => (
          <div key={key}>
            <p>
              <strong className="tw-text-primary">{formatKey(key)}:</strong>{" "}
              {value ? value : "-"}
            </p>
          </div>
        ))}
      </div>
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-w-full tw-mt-3">
        {identificationPicFront && (
          <IdentificationImage
            image={identificationPicFront}
            keyVal={"Front Identification Picture"}
          />
        )}
        {identificationPicBack && (
          <IdentificationImage
            image={identificationPicBack}
            keyVal={"Back Identification Picture"}
          />
        )}
      </div>
    </section>
  );
};

export default AccountDetailsProfile;
